<template>
  <slot />
</template>

<script setup lang="ts">
import {debounce} from 'es-toolkit';
import {onMounted, unref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import useAccount from '@/composables/useAccount/useAccount';
import useAcl from '@/composables/useAcl';
import useAppcues from '@/composables/useAppcues';
import useHotjar from '@/composables/useHotjar';
import useUiSettings from '@/composables/useUiSettings';

const MINIMUM_WAITING_TIME = 500;

const {acl} = useAcl();
const {account} = useAccount();
const {uiSettings} = useUiSettings();
const {isInitialized, updateUserIdentity, initAppcues, trackAppcuesPage} = useAppcues();
const {initHotjar} = useHotjar();
const {locale} = useI18n();

const debouncedUpdateIdentity = debounce(() => updateUserIdentity(unref(locale)), MINIMUM_WAITING_TIME);

/**
 * Watcher to update the appcues identifier.
 * We debounce changes so a burst of reactive updates results in a single identify call.
 */
/* istanbul ignore next */
watch([uiSettings, acl, account, locale], () => {
  if (isInitialized()) {
    debouncedUpdateIdentity();
  }
});

/* istanbul ignore next */
onMounted(async () => {
  const [, appcuesInitialized] = await Promise.all([initHotjar(), initAppcues(unref(locale))]);
  if (appcuesInitialized) {
    trackAppcuesPage();
  }
});
</script>
